// extracted by mini-css-extract-plugin
export default {"videoBg":"videoBg_videoBg__lkqiN","bgDarken":"videoBg_bgDarken__RAPxJ","hidden":"videoBg_hidden__hxxin"};